import React, { Component } from 'react';
import './IndexComponent.scss';

class IndexComponent extends Component {
  render() {
    return (
      <>
        <div className="fb-container-1">
          <img
            src="logo/logo-siampiwat.svg"
            className="logo"
            alt="Feedback180"
          />
          <div className="fb-title">Temporary Downtime</div>
          <div className="sub-title">
            This survey is offline for maintenance. Please visit
            <a href="https://www.siampiwat.com/landing/">Siampiwat.com</a>
            for more information.
          </div>
        </div>
        <div className="footer-fb">
          <span>Powered by</span>
          <img
            src="icon-fb180.svg"
            className="power_by"
            alt="Powered by Feedback180"
          />
          <span> | Privacy Policy</span>
        </div>
      </>
    );
  }
}

export default IndexComponent;
